import { Redirect, Router } from '@reach/router'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './styles/main.css'
import './styles/reset.css'

window.global = window

const PublicLayout = React.lazy(() => import('./routes/public/Layout'))
const Home = React.lazy(() => import('./routes/public/Home'))
const FeaturedClasses = React.lazy(() => import('./routes/public/FeaturedClasses'))
const AdminLogin = React.lazy(() => import('./routes/public/AdminLogin'))
const Login = React.lazy(() => import('./routes/public/Login'))
const Preview = React.lazy(() => import('./routes/public/Preview'))
const Player = React.lazy(() => import('./routes/public/Player'))
const Program = React.lazy(() => import('./routes/public/ProgramPreview'))
const ProgramCommunity = React.lazy(() => import('./routes/public/ProgramCommunity'))
const Category = React.lazy(() => import('./routes/public/Category'))
const Coach = React.lazy(() => import('./routes/public/Coach'))
const Subscribe = React.lazy(() => import('./routes/public/Subscribe'))
const AdminLayout = React.lazy(() => import('./routes/admin/Layout'))
const Dashboard = React.lazy(() => import('./routes/admin/Dashboard'))
const Stats = React.lazy(() => import('./routes/admin/Stats'))
const LessonEdit = React.lazy(() => import('./routes/admin/LessonEdit'))
const Builder = React.lazy(() => import('./routes/Builder'))
const SectionForm = React.lazy(() => import('./routes/Builder/SectionForm'))
const ProgramForm = React.lazy(() => import('./routes/Builder/ProgramForm'))
const CategoryForm = React.lazy(() => import('./routes/Builder/CategoryForm'))
const Suggestions = React.lazy(() => import('./routes/Builder/Suggestions'))
const CoachForm = React.lazy(() => import('./routes/Builder/CoachForm'))
const LiveStreamForm = React.lazy(() => import('./routes/Builder/LiveStreamForm'))
const Live = React.lazy(() => import('./routes/public/Live'))
const LivePlayer = React.lazy(() => import('./routes/public/LivePlayer'))
const LiveStramPreview = React.lazy(() => import('./routes/Builder/LiveStramPreview'))
const Checkout = React.lazy(() => import('./routes/public/Checkout'))
const Feedback = React.lazy(() => import('./routes/public/Feedback'))

const Settings = React.lazy(() => import('./routes/Settings/Settings'))
const SettingsProfile = React.lazy(() => import('./routes/Settings/Profile'))
const SettingsPayment = React.lazy(() => import('./routes/Settings/Payment'))
// Landing Pages
const Payment = React.lazy(() => import('./routes/Landing/Payment'))
const PaymentCheckout = React.lazy(() => import('./routes/Landing/Checkout'))

const PaymentPromo = React.lazy(() => import('./routes/Landing/Payment/Promo'))
const PaymentCheckoutPromo = React.lazy(() => import('./routes/Landing/Checkout/Promo'))

const CompanySignup = React.lazy(() => import('./routes/Landing/Company'))
function App() {
  return (
    <React.StrictMode>
      <Suspense fallback={<div></div>}>
        <Router>
          <AdminLogin path="/superheros" />
          <Login path="/login" />
          <Payment path="/payment" />

          <CompanySignup path="/company/signup" />

          <PaymentPromo path="/payment/edenred" />
          <PaymentCheckoutPromo path="/checkout/edenred" />
          <PaymentCheckout path="/checkout" />

          <Home path="/explora" />
          <FeaturedClasses path="/explora/featuredClasses" />
          <Preview path="/lesson/:lessonId" />
          <Category path="/Category/:title" />
          <Coach path="/Coach/:title" />
          <Live path="/LiveStream/:itemId" />
          <LivePlayer path="/LivePlayer/:itemId" />
          <Program path="/ProgramPreview/:title" />
          <Feedback path="/Feedback" />

          <Redirect from="/" to="/explora" />

          <Settings path="/Settings">
            <SettingsProfile path="/Profile" />
            <SettingsPayment path="/Payment" />
          </Settings>

          <PublicLayout path="/">
            <Player path="/player/:lessonId" />
            <Checkout path="/Checkout" />
            <ProgramCommunity path="/ProgramPreview/:title/Community" />
            <Subscribe path="/subscribe" />
          </PublicLayout>

          <AdminLayout path="/dashboad">
            <Dashboard path="/" />
            <LessonEdit path="/lesson/:lessonId" />
            <Stats path="/stats" />
            <Builder path="/builder">
              <SectionForm path="/" />

              <CategoryForm path="/Category" />
              <CategoryForm path="/Category/:id" />

              <ProgramForm path="/ProgramPreview" />
              <ProgramForm path="/ProgramPreview/:id" />

              <LiveStreamForm path="/LiveStream" />
              <LiveStreamForm path="/LiveStream/:id" />

              <CoachForm path="/Coach" />
              <CoachForm path="/Coach/:id" />
            </Builder>
            <Suggestions path="/suggestions" />

            <LiveStramPreview path="/LiveStream/:id/preview" />
          </AdminLayout>
        </Router>
      </Suspense>
    </React.StrictMode>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
